import { render, staticRenderFns } from "./add-or-update.vue?vue&type=template&id=3e8d24b8&scoped=true&"
import script from "./add-or-update.vue?vue&type=script&lang=js&"
export * from "./add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./add-or-update.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./add-or-update.vue?vue&type=style&index=1&id=3e8d24b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8d24b8",
  null
  
)

export default component.exports